import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Row, Col } from "react-bootstrap"
import "./header.scss"
import { graphql, Link, useStaticQuery } from "gatsby"
import Language from "./language"
import MainMenu from "../Menu/mainMenu"
import { useIntl } from "gatsby-plugin-react-intl"
import { debounce } from "../functions"
import { generateUrlByLocale } from "../../services/intl.service"
import Logo from "./logo"
import BookButton from "./button"
import SearchInput from "../common/searchInput"
import ResortsMenu from "../Menu/resortsMenu"
import ResortsMenuMobile from "../Menu/resortsMenuMobile"
import QuoteLink from "../common/quoteLink"
import PlanYourStay from "../common/planYourStayLink"
import { globalHistory } from "@reach/router"
import { HOTEL_TAXONOMY_VERANDA_RESORTS_ID } from "../../constants"

const Header = ({ siteTitle, pageContext, menus, hotelId }) => {
  const intl = useIntl()
  const breakpoint = 1025

  const [screen, setMobile] = useState({
    isMobile: typeof window !== `undefined` && window.innerWidth < breakpoint,
  })

  const [isClient, setClient] = useState(false)

  const handleMenuMob = () => {
    const mobNavBtn = document.querySelector(".btnNavMob")
    const mobNavCont = document.querySelector(".mainNav")
    const globalBlk = document.querySelector("#global")
    mobNavBtn.classList.toggle("open")
    mobNavCont.classList.toggle("open")
    globalBlk.classList.toggle("menu-open")
  }

  //Remove class 'menu-open' when url changes
  useEffect(() => {
    if (screen.isMobile) {
      return globalHistory.listen(({ action }) => {
        if (action === "PUSH") {
          document.body.classList.remove("menu-open")
        }
      })
    }
  }, [])

  useEffect(() => {
    setClient(true)

    const debouncedHandleResize = debounce(function handleResize() {
      setMobile({
        isMobile:
          typeof window !== `undefined` && window.innerWidth < breakpoint,
      })
    }, 200)

    if (typeof window !== `undefined`) {
      window.addEventListener("resize", debouncedHandleResize)
    }
  }, [])

  const data = useStaticQuery(graphql`
    query HotelPathQuery {
      allNodeHotel(filter: { title: { ne: "Dummy" } }) {
        nodes {
          title
          path {
            alias
            langcode
          }
          relationships {
            hotel_hotel {
              drupal_id
            }
          }
        }
      }
      resortMenuEn: allMenuLinkContentHotelMenu(
        filter: { enabled: { eq: true }, title: { ne: "Dummy" }, langcode: { eq: "en" } }
        sort: { fields: weight }
      ) {
        nodes {
          id
          title
          link {
            url
          }
          langcode
        }
      }
      resortMenuFr: allMenuLinkContentHotelMenu(
        filter: { enabled: { eq: true }, title: { ne: "Dummy" }, langcode: { eq: "fr" } }
        sort: { fields: weight }
      ) {
        nodes {
          id
          title
          link {
            url
          }
          langcode
        }
      }
    }
  `)

  const hotel = data.allNodeHotel.nodes.find(
    node =>
      node.relationships.hotel_hotel.drupal_id ===
      pageContext.hotelTaxonomyDrupalId && node.path.langcode === intl.locale
  )

  let locale, resorts
  if (pageContext.localeBlog) {
    locale = pageContext.localeBlog.toLowerCase()
  } else {
    locale = intl.locale
  }

  const hotelPath =
    pageContext.hotelTaxonomyDrupalId &&
      pageContext.hotelTaxonomyDrupalId !== HOTEL_TAXONOMY_VERANDA_RESORTS_ID
      ? generateUrlByLocale(hotel.path.langcode, hotel.path.alias)
      : locale === "en"
        ? "/en"
        : "/"

  switch (locale) {
    case "fr":
      if (data.resortMenuFr) {
        resorts = data.resortMenuFr.nodes
      }
      break;
    default:
      if (data.resortMenuEn) {
        resorts = data.resortMenuEn.nodes
      }
      break;
  }

  return (
    <header className="mast">
      <div className="container-fluid">
        <div className="headRow">
          <div className="colLogo">
            <Link aria-label="Veranda Resorts" to={hotelPath}>
              <Logo
                hotelId={pageContext.hotelTaxonomyDrupalId}
                locale={locale}
              />
            </Link>
          </div>
          <div className="colElements">
            <Row>
              <Col md={3}>
                <ResortsMenu resortItems={resorts} locale={locale} hotelId={pageContext.hotelTaxonomyDrupalId} hotelName={pageContext.hotelName} />
              </Col>
              <Col md={9}>
                <div>
                  <PlanYourStay
                    hotelId={pageContext.hotelTaxonomyDrupalId}
                    locale={locale}/>
                </div>
                <div>
                  <QuoteLink
                    hotelId={pageContext.hotelTaxonomyDrupalId}
                    locale={locale}
                  />
                </div>
                <div className="bookLink">
                  <BookButton
                    hotelId={pageContext.hotelTaxonomyDrupalId}
                    locale={locale}
                  />
                </div>
                <div>
                  <Language pageContext={pageContext} />
                </div>
                {isClient && screen.isMobile ? (
                  <div>
                    <button
                      aria-label="Menu Mob"
                      className="btnNavMob"
                      onClick={handleMenuMob}
                    >
                      <div className="bar-one" />
                      <div className="bar-two" />
                      <div className="bar-three" />
                    </button>
                  </div>
                ) : (
                  <>

                  </>
                )}
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <MainMenu menus={menus} locale={locale} />
              </Col>
              <Col md={4}>
                <SearchInput />
                <div>
                  <a aria-label="Tel" href="tel:+230 260 5101">
                    <i className="icon-tel"></i>
                  </a>
                </div>
                <div>
                  <Link aria-label="Mail" to={locale == "en" ? "/en/contact-en" : "/contact"}>
                    <i className="icon-mail"></i>
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        {isClient && screen.isMobile ? (
          <>
            <Row className="mainNav">
              <Col xs={12}>
                <ResortsMenuMobile resortItems={resorts} locale={locale} hotelId={pageContext.hotelTaxonomyDrupalId} hotelName={pageContext.hotelName} />
                <MainMenu menus={menus} locale={locale} />
              </Col>
            </Row>
          </>
        ) : (
          <>

          </>
        )}
      </div>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
